import {
  EmptyStateCnt,
  EmptyStateHeading,
  EmptyStateSubText,
} from './taskListWidgetEmptyState.style';
import React from 'react';
import DueTodayEmptyStateImage from 'public/assets/img/dueTodayReportEmptyState.svg';

const DueTodayEmptyState = () => {
  return (
    <EmptyStateCnt>
      <img
        alt="dueTodayEmptyState"
        src={DueTodayEmptyStateImage}
        style={{ width: 226, height: 150 }}
      />
      <EmptyStateHeading variant={'h3'}>Way to go!</EmptyStateHeading>
      <EmptyStateSubText>
        You have no tasks due today. Keep up the great work!
      </EmptyStateSubText>
    </EmptyStateCnt>
  );
};

export default DueTodayEmptyState;
